export const getTimezone = () => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
  const isTimeZoneUndefined = !timeZone

  return { timeZone: timeZone ?? 'Australia/Melbourne', isTimeZoneUndefined }
}
